export default {
    login: {
        email: 'Email',
        password: 'Password',
        remember: 'Remember Me',
        connect: 'Login',
        forgotPassword: 'Forgot Your Password?',
        failed: 'These credentials are incorrect.',
    },
    forgotPassword: {
        pageTitle: 'Forgot Password',
        email: 'Email',
        instructions: 'Enter the email address linked to the account for which you would like to reset the password.',
        userNotFound: 'No user is associated to the specified email.',
        invalidEmail: 'The specified email is invalid.',
        unknownError: 'An unknown error occured.',
        emailSentTitle: 'Email sent',
        emailSentText: 'A password reset email has been sent to your email address.',
    },
    newPassword: {
        pageTitle: 'New password',
        instructions: 'Please enter a new password (at least 8 characters).',
        password: 'Password',
        passwordConfirmation: 'Retype password',
        changePassword: 'Change password',
        passwordChanged: 'Your password has been changed successfully.',
    },
};
